import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Header.css";

const Header = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((v) => !v);
  const close = () => setOpen(false);

  return (
    <header className="global-header">
      <div className="gh-content">
        
        {/* ✅ LOGO CLIQUABLE */}
        <Link to="/" onClick={close}>
          <img src="/logo.png" alt="Logo Find ID" className="gh-logo" />
        </Link>

        <button
          className="menu-badge"
          onClick={toggle}
          aria-haspopup="true"
          aria-expanded={open}
          aria-label="Ouvrir le menu"
        >
          <svg
            className="menu-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
      </div>

      {open && (
        <>
          <button
            className="menu-overlay-fixed"
            onClick={close}
            aria-label="Fermer le menu"
          />
          <aside className="menu-panel-fixed" role="menu">
            <div className="menu-header">
              <span>Menu</span>
              <button className="menu-close" onClick={close} aria-label="Fermer">
                ×
              </button>
            </div>
            <nav className="menu-list">
              <Link to="/" onClick={close}>Accueil</Link>
              <Link to="/piece-ramace" onClick={close}>Déclarer une pièce Ramassée</Link>
              <Link to="/piece-perdu" onClick={close}>Déclarer une pièce perdue</Link>
              <Link to="/mes-declarations" onClick={close}>Mes déclarations</Link>
              {/* <Link to="/admin-login" onClick={close}>Admin</Link> */}
            </nav>
          </aside>
        </>
      )}
    </header>
  );
};

export default Header;